<template>
  <div>
    <van-tabbar v-model="active" active-color="#101010">
    <van-tabbar-item to="/newindex">
      <span>首页</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/newindex_active.png') : require('../assets/img/index.png')" />
      </template>
    </van-tabbar-item>
    <van-tabbar-item  to="/myclients">
      <span>我的客户</span>
      <template #icon="props">
        <img :src="props.active ? require('../assets/img/mine_active.png'):require('../assets/img/newmy.png')" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
  </div>
</template>

<script>
export default {
  
  data(){
    return{
      active: 0,
    }
  },
  watch:{
    $route(){
      console.log(this.$route)
      if(this.$route.path=='/myclients'){
        this.active=1
      }else{
        this.active=0
      }
    }
  },
  mounted(){
    if(this.$route.path=='/myclients'){
        this.active=1
      }else{
        this.active=0
      }
  }
  
};
</script>

<style scoped lang="less">
.footer {
  border-top: 1px solid #ebebeb;
  height: 50px;
  position: fixed;
  bottom: 0;
  width: 100%;
  bottom: 0;
  left: 0;
  .text {
    color: #797d82;
  }
  .active .text {
    color: @orange;
  }
  .tab_img{
    width: 28px;
    height: 28px;
  }
}
</style>
